import React from 'react';

import PropTypes from 'prop-types';

import {Form, Divider} from 'semantic-ui-react';
import _ from 'lodash';

import RadioField from './formComponents/radioField';
import DateField from './formComponents/dateField';
import TextboxField from './formComponents/textboxField';
import TextareaField from './formComponents/textareaField';
import withAdditionalContent from './formComponents/withAdditionalContent';
import StaticText from './formComponents/staticText';

import ExpressionUtils from 'app-ui-componentlibrary/dist/go/components/common/ExpressionUtils';

// DEPRECATED, use other DynamicForm for a configuration component that renders a Form
const DynamicForm = class DynamicForm extends React.Component {
  static propTypes = {
    /** A unique id for the form */
    id: PropTypes.string.isRequired,

    /** The configuration of the form (fields that compose the form) */
    config: PropTypes.array.isRequired,

    /** The model object that backs the form */
    model: PropTypes.object.isRequired,

    /** Whether the entire form should be disabled */
    disabled: PropTypes.bool,

    /** A function that gets called before model updates,
     *  supplied with the updated model ("uncommitted") whose return value
     *  is a boolean to indicate whether to continue the update cycle
     */
    preUpdateModel: PropTypes.func,

    /** A function that gets called after model updates,
     *  supplied with the updated model ("committed") */
    postUpdateModel: PropTypes.func,
  };

  static FORM_COMPONENTS = {
    radio: RadioField,
    date: DateField,
    textbox: TextboxField,
    textarea: TextareaField,
    statictext: StaticText,
  };

  static generateFormFieldId = (type, id) => `${type}_${id}`;

  constructor(props) {
    super(props);

    this.formId = props.id;
    this.state = {};
    this.preUpdateModel = props.preUpdateModel;
    this.postUpdateModel = props.postUpdateModel;
  }

  render() {
    let {model, config} = this.props;
    return (
      <Form>
        {config.map((question, i) => {
          const {options, questionType, id, modelKey, title, rules} = question;

          let FormComponentType = DynamicForm.FORM_COMPONENTS[questionType];
          if (options && options.additionalContent) {
            FormComponentType = withAdditionalContent(FormComponentType);
          }
          /** If the component should be hidden, do no more... */
          if (ExpressionUtils.isHidden(question, model)) {
            return null;
          }

          const fieldId = DynamicForm.generateFormFieldId(
            questionType,
            this.formId + '_' + id
          );

          return (
            <React.Fragment key={this.formId + '_' + id}>
              <FormComponentType
                id={fieldId}
                title={title}
                modelKey={modelKey}
                value={_.get(model, modelKey)}
                blurModel={this.props.blurModel}
                updateModel={this.props.updateModel}
                {...options}
                rules={rules}
                disabled={this.props.disabled}
              />
              <Divider />
            </React.Fragment>
          );
        })}
      </Form>
    );
  }
};

DynamicForm.defaultProps = {
  disabled: false,
};

export default DynamicForm;
